import { render } from "./ShowFamilyMembers.vue?vue&type=template&id=2343da23"
import script from "./ShowFamilyMembers.vue?vue&type=script&lang=js"
export * from "./ShowFamilyMembers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__